import React, { useEffect } from "react";
import "./App.css";
import "../src/assets/css/style.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import MyRouts from "./Routers/routes";
import "bootstrap/dist/css/bootstrap.min.css";
import { useDispatch, useSelector } from "react-redux";
import { getProfile } from "store/Profile/actions";
import Loading from "Component/common/Loading";

function App() {
  const isAuthenticated = useSelector((s) => s?.login?.token);
  const loading = useSelector((s) => s?.profileData?.loading);

  const dispatch = useDispatch();

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(getProfile());
    }
  }, []);

  if (isAuthenticated && loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center h-100 w-100 position-fixed inset-0 z-100"
        style={{
          background: "#00000033",
          zIndex: 99,
          right: 0,
          top: 0,
        }}
      >
        <Loading />
      </div>
    );
  }

  return (
    <div className="App">
      <MyRouts isAuthenticated={isAuthenticated} />
    </div>
  );
}

export default App;
